import { ChallengeDefinitionInvalidError, collectListenedEventTypes, validateChallengeDefinition, } from './challenge-definition.js';
import { SCENARIO_1_PATIENT_ONBOARDING } from './scenarios/scenario-1-patient-onboarding.js';
/**
 * Code/config registry of challenge definitions. Versioned in source — no
 * builder UI, no DB row. Validates every entry at module load: a goal that
 * references an unknown event type fails the build, not silently at runtime.
 */
const ALL_DEFINITIONS = [SCENARIO_1_PATIENT_ONBOARDING];
ALL_DEFINITIONS.forEach(validateChallengeDefinition);
const BY_ID = new Map(ALL_DEFINITIONS.map((d) => [d.id, d]));
export const ChallengeRegistry = {
    getById: (id) => {
        const def = BY_ID.get(id);
        if (!def) {
            throw new ChallengeDefinitionInvalidError(`No challenge registered with id "${id}"`);
        }
        return def;
    },
    /** Challenge served by default to a freshly-provisioned challenge office. */
    getDefault: () => SCENARIO_1_PATIENT_ONBOARDING,
    all: () => ALL_DEFINITIONS,
    /** Union of event types any goal in any challenge listens for. */
    listenedEventTypes: () => collectListenedEventTypes(ALL_DEFINITIONS),
};
//# sourceMappingURL=challenge-registry.js.map